import { ChevronDown } from 'lucide-react'
import { Button, Container, Stack, Text } from '@/components/ui/index.js'
import styles from './HeroSection.module.css'

interface HeroSectionProps {
  onLogin: (provider: 'kakao' | 'naver') => void
}

export function HeroSection({ onLogin }: HeroSectionProps) {
  return (
    <section className={styles.hero}>
      <Container size="md">
        <Stack align="center" gap={6}>
          <Text variant="heading-xl" className={styles.logo}>Cuggu</Text>
          <Text variant="heading-xl" align="center" className={styles.headline}>
            세상에 하나뿐인<br />모바일 청첩장
          </Text>
          <Text variant="body-lg" color="secondary" align="center" className={styles.subtext}>
            인사말, 갤러리, 식순, 지도, RSVP까지.<br />
            모든 것을 담은 모바일 청첩장을 쉽고 예쁘게 만들어 보세요.
          </Text>
          <Stack direction="row" gap={3} className={styles.buttons}>
            <Button size="lg" className={styles.kakao} onClick={() => onLogin('kakao')}>
              카카오 로그인
            </Button>
            <Button size="lg" className={styles.naver} onClick={() => onLogin('naver')}>
              네이버 로그인
            </Button>
          </Stack>
        </Stack>
      </Container>
      <div className={styles.scrollHint}>
        <ChevronDown size={28} />
      </div>
    </section>
  )
}
